export enum VehicleType {
  CAMPERVAN = 'Campervan',
  MOTORBIKE = 'Motorbike',
  SUV = 'SUV',
  VAN = 'Van',
  CAR = 'Car',
  TRUCK = 'Truck'
}
